const HelpPageDeliveryService = function ($rootScope, restangular, trolleyService, addressService, settingsService, $timeout, $log) {
     this.$log = $log;
     this._deliveryInfoApi = restangular.one('Delivery');

     this.deliveryTimeTable = undefined;
     this.nextDeliveryTime = null;
     this.hideAsapTimeOption = false;
};

HelpPageDeliveryService.prototype.transformDeliveryEstimate = function (data) {
    this.hideAsapTimeOption = false;

    try {
        let mins = Math.ceil(data.Minutes / 5) * 5;
        let hrs = data.Hours;
        const days = data.Days;
        const isHoursLessThanOne = hrs === 0;
        let asapTime;

        //move minutes to the hour
        if (mins === 60) {
            hrs = hrs + 1;
            mins = 0;
        }

        if (days > 0 || hrs >= 3 || hrs === 0 && mins < 15) {

            this.hideAsapTimeOption = true;
        } else if (mins === 0) {
            asapTime = hrs === 1 ? hrs + 'hr' : hrs + 'hrs';
        } else if (mins < 60) {
            asapTime = isHoursLessThanOne ? mins + 'mins' : hrs + 'hr' + (hrs === 1 ? ' ' : 's ') + mins + 'mins';
        } else {
            asapTime = hrs + 'hrs';
        }

        return asapTime;
    } catch (e) {
        this.$log.log(e, 'There are no delivery windows enabled for this store');
    }
};

HelpPageDeliveryService.prototype.getDeliveryWindowTime = function (dto) {
    this.nextDeliveryTime = null;
    return this._deliveryInfoApi.one('DeliveryWindowForCurrentDeliveryStore')
        .get(dto)
        .then((res) => {
            this.deliveryTimeTable = res.DeliveryWindows;
            this.nextDeliveryTime = this.transformDeliveryEstimate(res.NextAvailableDeliveryETAInTimeSplit);
            this.nextDeliveryETATime = this.transformNextDeliveryTime(res.NextAvailableDeliveryAt.NextDeliveryAtTime);
        }, (res) => {
            this.deliveryErrorMessage = res.data.Message;
        });
};

HelpPageDeliveryService.prototype.transformNextDeliveryTime = function (data) {
    if (!data) {
        return null;
    }

    const split = data.split(':');
    if (split.length > 1) {
        const hour = split[0];
        const suffix = hour >= 12 ? 'pm' : 'am';
        const formattedHour = hour > 12 ? hour - 12 : hour;
        return formattedHour + ':' + split[1] + ' ' + suffix;
    }

    return null;
};

module.exports = HelpPageDeliveryService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/help/help-page-delivery-service.js
 **/